import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { post, put, get } from 'helpers/apiHelpers';
import { useGetCompanyDefaultLanguage } from 'hooks/redux/Translatable/useTranslatableLanguages';

import FormView from './Form.view';
import defaultState from '../defaultState';

const FormContainer = ({ match, location, history }) => {
  const { t } = useTranslation();
  const companyDefaultLanguage = useGetCompanyDefaultLanguage();

  const [state, setState] = useState({ ...defaultState });

  const categoryId = match?.params?.id;
  const isEdit = location?.pathname.includes('edit');

  useEffect(() => {
    if (!isEdit) {
      return;
    }
    const prefillForm = async () => {
      try {
        const category = await get(`/dish-categories/${categoryId}`, {
          translations: true,
        });

        setState(prev => ({
          ...prev,
          name: category.name,
          position: category.position,
          dishesSortOrder: category.dishesSortOrder ?? prev.dishesSortOrder,
        }));
      } catch {
        toast.error(
          `${t('form.somethingWentWrong')} ${t('form.tryAgainLater')}`
        );
      }
    };

    prefillForm();
  }, [isEdit, categoryId, t]);

  const handleInputChange = event => {
    setState(prev => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleDishesSortOrderChange = (event, selectedOption) => {
    setState(prev => ({
      ...prev,
      dishesSortOrder: selectedOption?.key ?? prev.dishesSortOrder,
    }));
  };

  const validateForm = () =>
    !!state.name?.['@ContentTranslation']?.[companyDefaultLanguage] &&
    state.position !== '' &&
    state.position !== null;

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error(t('form.fillAllRequiredFields'));
      return;
    }

    const data = {
      name: state.name,
      position: parseInt(state.position, 10),
      dishesSortOrder: state.dishesSortOrder,
    };

    try {
      if (isEdit) {
        await put(`/dish-categories/${categoryId}`, data);
        toast.success(t('dishCategories.form.saved'));
      } else {
        await post('/dish-categories', data);
        toast.success(t('dishCategories.form.added'));
      }
      setState(prev => ({ ...prev, errors: {} }));
      history.push('/admin/dish-categories');
    } catch (error) {
      const dataResponse = error?.response?.data;

      if (dataResponse?.violations) {
        const tempErrors = dataResponse.violations.reduce(
          (acc, { message, propertyPath }) => ({
            ...acc,
            [propertyPath]: message,
          }),
          {}
        );
        setState(prev => ({ ...prev, errors: tempErrors }));
      } else {
        toast.error(
          `${t('form.somethingWentWrong')} ${t('form.tryAgainLater')}`
        );
      }
    }
  };

  return (
    <FormView
      state={state}
      isEdit={isEdit}
      handleInputChange={handleInputChange}
      handleDishesSortOrderChange={handleDishesSortOrderChange}
      handleSubmit={handleSubmit}
    />
  );
};

export default FormContainer;
